import timer from "../../library/util/timer";
import checkmateApi from "../axios/checkmateApi"
import { ForgotPayload, LoginPayload, PasswordPayload, RegisterPayload, ResetPasswordPayload } from "../slices/authSlice";
import { IUser } from "../slices/userSlice";


export const login = async (payload: LoginPayload) => {
    const response = checkmateApi({
        method: 'POST',
        url: `users/login`,
        data: {
            ...payload,
            "tokenExpiry": "7"
        }
    });
    return response;
}

export const mfaLogin = async (token: string) => {
    const response = checkmateApi({
        method: 'POST',
        url: `webhook/b2c/auth`,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
}

export const getLoggedInUser = async () => {
    const response = checkmateApi({
        method: 'GET',
        url: '/users/loggedInUser'
    });
    return response;
}

export const logout = async () => {
    // const response = checkmateApi({
    //     method: 'POST',
    //     url: 'logout'
    // });
    // return response;
    return timer({
        data: true
    }, 500);
}

export const register = async (payload: RegisterPayload) => {
    // const response = checkmateApi({
    //     method: 'POST',
    //     url: 'register',
    //     data: payload
    // });
    // return response;
    return timer({
        data: true
    }, 500)
}

export const forgotPassword = async (payload: ForgotPayload) => {
    // const response = checkmateApi({
    //     method: 'POST',
    //     url: 'forgot',
    //     data: payload
    // });
    // return response;
    return timer({
        data: true
    }, 500)
}

export const resetPassword = async (payload: ResetPasswordPayload) => {
    // const response = checkmateApi({
    //     method: 'POST',
    //     url: 'reset',
    //     data: payload
    // });
    // return response;
    console.log(payload);
    return timer({
        data: true
    }, 500);
}

export const updatePassword = async (payload: PasswordPayload, email: string) => {
    const data = {
        email,
        oldPassword: payload.currentPassword,
        password: payload.password
    };
    const response = checkmateApi({
        method: 'POST',
        url: `users/updatePassword`,
        data
    });
    return response;
}
